import animateScrollTo from "animated-scroll-to";

export function initScroll() {
	scroll();
}

function scroll() {
	$(".scroll").on("click", function (e) {
		e.preventDefault();

		animateScrollTo(document.querySelector($(this).attr("href")), {
			verticalOffset: window.innerWidth <= 992 ? -50 : -99,
			cancelOnUserAction: false,
		});

		if ($(this).hasClass("nav-link") && window.innerWidth <= 992) {
			$(".navbar-toggler").click();
		}
	});
}
